import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCmsQuery } from '../../api/cmsApi';

export const getCms = createAsyncThunk('cms/getCms', async (data, { dispatch }) => {
    dispatch(resetReducer())
    const response = await getCmsQuery(data);
    return response.data;
});



const cmsSlice = createSlice({
    name: 'cms',
    initialState: {
        cmsLoader: false,
        title_en: "",
        content_en: "",
        title_ar: "",
        content_ar: "",
        status: null,
        message: ""
    },
    reducers: {
        resetReducer: (state) => {
            state.title_en = ""
            state.content_en = ""
            state.title_ar = ""
            state.content_ar = ""
            state.status = null
            state.message = ""
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCms.pending, (state, action) => {
                state.cmsLoader = true;
                state.status = false;
            })
            .addCase(getCms.fulfilled, (state, action) => {
                state.title_en = action.payload.data.title_en
                state.title_ar = action.payload.data.title_ar
                state.content_en = action.payload.data.description_en
                state.content_ar = action.payload.data.description_ar
                state.message = action.payload.msg
                state.cmsLoader = false;
                state.status = true
            })
            .addCase(getCms.rejected, (state, action) => {
                state.cmsLoader = false;
                state.status = false;
            });
    },
});

export const { resetReducer } = cmsSlice.actions;
export default cmsSlice.reducer;
